import { Splide } from '../lib/splide.esm.js';

const podcast = {

	elem: {
		podcastImages: document.querySelectorAll('.c26-podcast__image img'),
		podcastSlider: document.querySelector('.c26-podcast .splide')
	},

	modifier: -1,

	mql: window.matchMedia('(min-width: 1024px)'),		
	
	splide: [],

	init() {
		if(podcast.mql.matches) {
			podcast.elem.podcastSlider.querySelector('.splide__slide').remove();
			podcast.modifier = 0;
			podcast.elem.podcastImages[0].classList.add('shown');
		}
		
		if(podcast.elem.podcastSlider) {
			podcast.splide.unshift(new Splide(podcast.elem.podcastSlider, {
				type: 'fade',
				perPage: 1,
				slidesToShow: 1,
				arrows: true,
				drag: true,
				pagination: false,
				mediaQuery: 'min',
			}).on('move', podcast.update).mount());
		}		
	},

	update(newIndex) {
		podcast.elem.podcastImages.forEach(function(element, index) {
			element.classList.remove('shown');
			if(index === (newIndex + podcast.modifier)) {
				element.classList.add('shown');
			}
		});
	}

};

export { podcast };




